if (!customElements.get('gif-images')) {
    customElements.define('gif-images', class DetailsCustom extends HTMLElement {
        constructor() {
            super()
            
            var gif_slides = this.querySelectorAll('.three-products__slide:not([data-gif-image=""])')

            window.addEventListener('DOMContentLoaded', () => {
                Promise.all(Array.from(gif_slides).map((slide) => {
                    return this.loadImage(slide)
                })).then((images) => {
                    console.log('images', images)
                    images.forEach((result) => {
                        result.image.src = result.gif_image
                        result.image.srcset = result.gif_image
                    })
                })
            }, { once: true })            
        }

        loadImage(slide) {

            var current_image = slide.querySelector('img')

            if(!current_image) return

            var gif_image_src = slide.dataset.gifImage;

            //load image first and then replace
            const new_image = new Image()
            new_image.src = gif_image_src

    
            return new Promise((resolve, reject) => {
                new_image.onload = () => {
                    resolve({
                        image: current_image,
                        gif_image: gif_image_src
                    })
                }
            })
        }
    })

}